import {withDispatchActions} from "../../../../shared/hoc/withDispatchActions";
import TagItem from "../../../pages/tags-info/TagItem";
import {toggleFenceEditModeActions} from "../FencesContainer.helpers";

const TagItemWithToggleActions = withDispatchActions(TagItem, toggleFenceEditModeActions);

export default TagItemWithToggleActions;